module.exports = __webpack_public_path__ + "static/media/uc-logo.39a79c95.png";